export default __webpack_public_path__ + "static/media/Smiling2.1a4162ae.svg";